// extracted by mini-css-extract-plugin
module.exports = {"main":"style-module--main--3YZQR"};